export const SIZES = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 20, 24, 32, 48, 64];

export const FORMATS = {
  single_elimination: { label: 'Single Elimination', short: 'Single Elim', color: 'bg-[#00247D]' },
  double_elimination: { label: 'Double Elimination', short: 'Double Elim', color: 'bg-purple-600' },
  consolation: { label: '3-Game Guarantee', short: 'Consolation', color: 'bg-amber-600' },
};

export const TEMPLATES = [
  ...['single_elimination', 'double_elimination'].flatMap((format) => SIZES.map((numTeams) => ({ id: `${format}_${numTeams}`, format, numTeams }))),
  { id: 'consolation_8', format: 'consolation', numTeams: 8 },
];

export const templateById = (id) => TEMPLATES.find((t) => t.id === id) || null;

export const baseTitle = (numTeams, format) => `${numTeams} TEAM ${FORMATS[format].label.toUpperCase()} BRACKET`;

const nextPow2 = (n) => { let s = 1; while (s < n) s *= 2; return s; };

// Bracket formats the wizard can run as a managed tournament for `n` teams.
export function bracketFormatsFor(n) {
  const byes = n > 1 ? nextPow2(n) - n : 0;
  return [
    { format: 'single_elimination', label: `${n}-Team Single Elimination`, games: n - 1, byes, ok: n >= 2 && n <= 64, reason: 'Needs 2 to 64 teams' },
    { format: 'double_elimination', label: `${n}-Team Double Elimination`, games: 2 * n - 2, byes, ok: n >= 3 && n <= 64, reason: 'Needs 3 to 64 teams' },
    { format: 'consolation', label: '8-Team 3-Game Guarantee', games: 12, byes: 0, ok: n === 8, reason: 'Needs exactly 8 teams' },
  ];
}

export const BRACKET_FORMAT_KEYS = Object.keys(FORMATS);
